/* tslint:disable */
/* eslint-disable */
/**
 * channels-com
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import { User, UserFromJSON, UserFromJSONTyped, UserToJSON } from './';

/**
 *
 * @export
 * @interface RegisterResponse
 */
export interface RegisterResponse {
  /**
   *
   * @type {User}
   * @memberof RegisterResponse
   */
  user: User;
  /**
   *
   * @type {string}
   * @memberof RegisterResponse
   */
  message: string;
}

export function RegisterResponseFromJSON(json: any): RegisterResponse {
  return RegisterResponseFromJSONTyped(json, false);
}

export function RegisterResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegisterResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    user: UserFromJSON(json['user']),
    message: json['message'],
  };
}

export function RegisterResponseToJSON(value?: RegisterResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    user: UserToJSON(value.user),
    message: value.message,
  };
}
